import { Container, Logo } from "./styles";
import capivara from "../../assets/images/capivara.png";
import { useNavigate } from "react-router-dom";
import { Page } from "../../components/page-base";
import { useEffect } from "react";

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 2000);
    /* eslint-disable-next-line */
  }, []);

  return (
    <Container>
      <Logo>
        <img src={capivara} alt="Logo" />
      </Logo>
      <span className="lbl">Página não encontrada</span>
      <div
        className="btns"
        onClick={() => {
          navigate("/");
        }}
      >
        <Page.Button type="button" label="Voltar ao inicio" />
      </div>
    </Container>
  );
};
